export default "__VITE_ASSET__R75ECGOE__"